import { Icon } from '../../../layout/Icon.jsx';
import { ProductTile } from './ProductTile.jsx';

export function ProductGrid({ products = [], loading, onAdd }) {
  if (loading) {
    return (
      <div className="card">
        <div className="card-b text-center py-10 text-ink-3">جاري تحميل المنتجات...</div>
      </div>
    );
  }
  if (!products.length) {
    return (
      <div className="card">
        <div className="card-b text-center py-10 text-ink-3 flex flex-col items-center gap-2">
          <Icon name="inventory" size={36} color="#D6CCB3" />
          <div>لا توجد منتجات مطابقة</div>
        </div>
      </div>
    );
  }
  return (
    <div
      className="grid gap-2.5"
      style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))' }}
    >
      {products.map((p) => (
        <ProductTile key={p._id || p.id} product={p} onAdd={onAdd} />
      ))}
    </div>
  );
}
